import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AllocationViewFacade } from '../../allocation-view/allocation-view.facade';
import { AllocationViewProfile } from '../models';
import { filter, take } from 'rxjs/operators';
import { AllocationViewProfileItemFacade } from '../item/allocation-view-profile-item.facade';

@Injectable({
  providedIn: 'root',
})
export class AllocationViewDefaultProfileGuard {
  constructor(
    private allocationViewProfileItemFacade: AllocationViewProfileItemFacade,
    private allocationViewFacade: AllocationViewFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    this.allocationViewProfileItemFacade.getDefaultProfile();

    this.allocationViewProfileItemFacade.defaultProfile$
      .pipe(filter(Boolean), take(1))
      .subscribe((defaultProfile: AllocationViewProfile) => {
        this.allocationViewFacade.setProfile(defaultProfile);
      });

    return of(true);
  }
}
